import { InvoiceStatusTranslatableEntry } from './InvoiceStatusTranslatableEntry';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { InvoiceStatus } from '../../../detail/types/InvoiceStatus';

export const invoiceStatusTranslations: InvoiceStatusTranslatableEntry[] = [
    {
        id: InvoiceStatus.DRAFT,
        name: marker('Entwurf'),
        description: 'Rechnung ist im Entwurfsstatus',
        color: '#6c757d',
        class: 'secondary',
        open: true,
        priority: 10,
    },
    {
        id: InvoiceStatus.CREATED,
        name: marker('Erstellt'),
        description: 'Rechnung wurde erstellt',
        color: '#0d6efd',
        class: 'primary',
        open: true,
        priority: 20,
    },
    {
        id: InvoiceStatus.UNAPPROVED,
        name: marker('Freigabe ausstehend'),
        description: 'Rechnung wurde noch nicht genehmigt',
        color: '#ffc107',
        class: 'warning',
        open: true,
        priority: 30,
    },
    {
        id: InvoiceStatus.APPROVED,
        name: marker('freigegeben'),
        description: 'Rechnung wurde genehmigt',
        color: '#198754',
        class: 'success',
        open: false,
        priority: 40,
    },
    {
        id: InvoiceStatus.CANCELED,
        name: marker('zurückgezogen'),
        description: 'Rechnung wurde storniert',
        color: '#6c757d',
        class: 'secondary',
        open: false,
        priority: 50,
    },
    {
        id: InvoiceStatus.REJECTED,
        name: marker('abgelehnt'),
        description: 'Rechnung wurde abgelehnt',
        color: '#dc3545',
        class: 'danger',
        open: false,
        priority: 60,
    },
    {
        id: InvoiceStatus.PAID,
        name: marker('bezahlt'),
        description: 'Rechnung wurde bezahlt',
        color: '#20c997',
        class: 'info',
        open: false,
        priority: 70,
    },
];
